import { render, staticRenderFns } from "./OrderDeliveries.vue?vue&type=template&id=2e7b10e6"
import script from "./OrderDeliveries.vue?vue&type=script&lang=js"
export * from "./OrderDeliveries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports